<template>
    <div :key="key">
        <base-alert v-if="apierror !== ''" type="danger">
        <strong>Fehler!</strong> {{ apierror }}
        </base-alert>
        <base-alert v-if="success" type="success" >
            Profil erfolgreich angelegt.
            <button type="button" class="close"  aria-label="Close" v-on:click="dismissSuccess">
                <span aria-hidden="true">&times;</span>
            </button>
        </base-alert>
        <form role="form" @submit="submit">
            <base-input class="input-group-alternative mb-3"
                        placeholder="Name"
                        addon-left-icon="fas fa-search"
                        v-model.trim="model.name">
            </base-input>
            <!----<button class="btn my-4 btn-primary" type="submit">Profil hinzufügen</button> --->
            <div class="btn-wrapper text-center mb-4">
                <base-button icon="ni ni-fat-add" size="sm" v-if="addprofile && valid" :disabled="success || isLoading" block :type="buttonType" native-type="submit">{{buttonText}}</base-button>
                <transition name="fade">
                    <base-button icon="fa fa-ban" size="sm" v-if="confirmation" block type="danger" v-on:click="abort">abbrechen</base-button>
                </transition>
            </div>
        </form>
    </div>

</template>

<script>



    export default {
        name: "AddProfile",
        props: {
            addprofile: Boolean
        },
        data() {
            return {
                model: {
                    name: '',
                    isActive: true,
                    comment: ''
                },
                success: false,
                apierror: '',
                isLoading: false,
                response: '',
                key: 1,
                confirmation: false,
                buttonText: "Neues Profil hinzufügen",
                buttonType: "secondary"
            }
        },
      computed: {
        valid() {
          return this.validString(this.model.name.trim())
        }
      },
        methods: {
            dismissSuccess() {
                this.success = false;
                this.key++;
            },
            validString(str) {
              // const trimmedStr = this.model.name.trim();
              // Check if the trimmed string has a length greater than 0
              return str.length > 0;
            },
            abort() {
                this.buttonText = "Neues Profil hinzufügen";
                this.buttonType = "secondary";
                this.confirmation = false;
            },
            submit(e) {
                e.preventDefault();
                if (this.validString(this.model.name)) {
                    if(this.confirmation){
                        const header = this.authHeader();
                        header['Content-Type'] ='application/json';
                        this.isLoading = true;
                        const requestOptions = {
                            method: 'POST',
                            headers: header,
                            body: JSON.stringify(this.model),
                        };
                        fetch(process.env.VUE_APP_API_SERVER+`/api/profiles`,requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                this.isLoading = false;
                                this.success = true;
                                this.apierror = '';
                                this.response = response;
                                this.buttonText = "Neues Profil hinzufügen";
                                this.buttonType = "secondary";
                                this.confirmation = false;
                                this.$store.dispatch('profiles/getProfiles');
                            }, response => {
                                //error handling
                                this.isLoading = false;
                                this.apierror = response;
                            });
                    } else {
                        this.buttonText = "Profil '"+this.model.name+"' anlegen?";
                        this.buttonType = "success";
                        this.confirmation = true;
                    }
                } else {
                    this.apierror = 'Bitte einen vollständigen und korrekten Namen für das Profil angeben.';
                }
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>